import { render } from "./StorePromoCodesView.vue?vue&type=template&id=c1885ed6&scoped=true"
import script from "./StorePromoCodesView.vue?vue&type=script&lang=js"
export * from "./StorePromoCodesView.vue?vue&type=script&lang=js"

import "./StorePromoCodesView.vue?vue&type=style&index=0&id=c1885ed6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1885ed6"]])

export default __exports__